import gql from 'graphql-tag'

export const userUpdate = gql`
  mutation userUpdate($userId: ID!, $userData: UserDataUpdateInput!) {
    userUpdate(input: { userId: $userId, userData: $userData }) {
      success
    }
  }
`
